import React, { useMemo, useState } from 'react';
import { Box, Paper, Typography, CircularProgress, Alert } from '@mui/material';
import { API_BASE_URL } from '../../services/config';

const MauticManual = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const src = useMemo(() => {
    // Use API base URL to avoid hitting React router
    const base = API_BASE_URL || window.location.origin;
    return `${base}/campaigns/mautic/proxy?path=/s/campaigns/new`;
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <Box sx={{ p: 2, height: '85vh', display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Création manuelle</Typography>
      </Paper>
      <Paper sx={{ overflow: 'hidden', flex: 1, display: 'flex', position: 'relative' }}>
        <Box sx={{ height: '100%', width: '100%', position: 'relative' }}>
          {isLoading && (
            <Box sx={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0, 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'center', 
              bgcolor: 'rgba(255, 255, 255, 0.9)',
              zIndex: 1
            }}>
              <CircularProgress size={40} sx={{ mb: 2 }} />
              <Typography variant="body2" color="text.secondary">
                Chargement de l'éditeur...
              </Typography>
            </Box>
          )}
          
          {hasError && (
            <Box sx={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              zIndex: 1
            }}>
              <Alert severity="error" sx={{ maxWidth: 400 }}>
                Erreur lors du chargement de l'éditeur. Veuillez réessayer.
              </Alert>
            </Box>
          )}
          
          <iframe
            title="Mautic Create Campaign"
            src={src}
            style={{ border: 'none', width: '100%', height: '100%' }}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default MauticManual;


